import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import GraphQLProvider from 'components/GraphQLProvider'
import { Provider as SharedEventBusContextProvider } from 'contexts/sharedEventBus'
import { CollabConnectionProvider } from '@slite/editor'

import { selectors as ConfigSelectors } from 'data/config'
import { actions as UIActions } from 'data/ui'

class PublicNotesRoot extends React.PureComponent {
  static propTypes = {
    collabEndpoint: PropTypes.string.isRequired,
    onConnectionChange: PropTypes.func.isRequired,
  }

  render() {
    return (
      <GraphQLProvider>
        <SharedEventBusContextProvider>
          <CollabConnectionProvider
            collabEndpoint={this.props.collabEndpoint}
            onConnectionChange={this.props.onConnectionChange}
          >
            {this.props.children}
          </CollabConnectionProvider>
        </SharedEventBusContextProvider>
      </GraphQLProvider>
    )
  }
}

const enhance = connect(
  function mapStateToProps(state) {
    return {
      apiEndpoint: ConfigSelectors.getApiEndpoint(state),
      collabEndpoint: ConfigSelectors.getCollabEndpoint(state),
    }
  },
  dispatch => ({
    onConnectionChange: status => {
      dispatch(UIActions.setConnectionStatus({ service: 'collab', status }))
    },
  })
)

export default enhance(PublicNotesRoot)
